import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { InvoiceMergeDataset } from './invoice.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.PrepaymentInvoice,
    dependsOn: [
        ActivityEntityName.Job
    ]
})
export class PrepaymentMergeDataset extends InvoiceMergeDataset {
}


